import { GLP1Ribbon } from '@common/GLP1Ribbon';
import { AtAGlanceSection } from '@components/AtAGlanceSection/AtAGlanceSection';
import { MounjaroAwardWinningProgramme } from '@components/AwardWinningProgramme/MounjaroAwardWinningProgramme';
import { MounjaroComparisonSection } from '@components/ComparisonSection/MounjaroComparisonSection';
import { MounjaroFAQsMedicallySupported } from '@components/FAQs/MounjaroFAQsMedicallySupported';
import { Footer } from '@components/Footer/Footer';
import { MounjaroLifelongResults } from '@components/LifelongResults/MounjaroLifelongResults';
import { MounjaroMedicallySupportedPlanHero } from '@components/MedicallySupportedPlanHero/MounjaroMedicallySupportedPlanHero';
import { MedicationSupportedHowItWorks } from '@components/MedicationSupportedHowItWorks/MedicationSupportedHowItWorks';
import { MounjaroMedicationSupportedWeightLoss } from '@components/MedicationSupportedWeightLoss/MounjaroMedicationSupportedWeightLoss';
import { MeetYourTeam } from '@components/MeetYourTeam/MeetYourTeam';
import Meta from '@components/Meta';
import { NavBar } from '@components/NavBar/NavBar';
import { NiceApprovalSection } from '@components/NiceApprovalSection/NiceApprovalSection';
import { mounjaroPageStructuredData } from '@common/structuredData';
import { MounjaroHabitBuilderSupport } from '../components/MounjaroHabitBuilderSupport';

const MedicationSupportedProgramme = (): JSX.Element => {
  let utmCampaign, utmMedium, utmSource;

  if (
    typeof window !== 'undefined' &&
    window.location &&
    window.location.search
  ) {
    const urlParams = new URLSearchParams(window.location.search);
    utmCampaign = urlParams.get('utm_campaign') ?? undefined;
    utmMedium = urlParams.get('utm_medium') ?? undefined;
    utmSource = urlParams.get('utm_source') ?? undefined;
  }

  return (
    <>
      <Meta
        metaDescription="You can buy Mounjaro online from Second Nature alongside our digital weight-loss programme. We've got all doses in stock, including the 2.5mg starting dose."
        relativeCanonicalURL="/mounjaro-weight-loss-programme"
        structuredData={mounjaroPageStructuredData}
        title="Second Nature's Mounjaro Medication Supported Programme"
      />
      <NavBar
        utmCampaign={utmCampaign}
        utmMedium={utmMedium}
        utmSource={utmSource}
      />
      <MounjaroMedicallySupportedPlanHero
        utmCampaign={utmCampaign}
        utmMedium={utmMedium}
        utmSource={utmSource}
      />
      <GLP1Ribbon />
      <MounjaroLifelongResults
        utmCampaign={utmCampaign}
        utmMedium={utmMedium}
        utmSource={utmSource}
      />
      <NiceApprovalSection
        medicationType="Mounjaro"
        utmCampaign={utmCampaign}
        utmMedium={utmMedium}
        utmSource={utmSource}
      />
      <MounjaroHabitBuilderSupport />
      <MounjaroMedicationSupportedWeightLoss />
      <MounjaroAwardWinningProgramme
        utmCampaign={utmCampaign}
        utmMedium={utmMedium}
      />
      <MounjaroComparisonSection
        utmCampaign={utmCampaign}
        utmMedium={utmMedium}
        utmSource={utmSource}
      />
      <MedicationSupportedHowItWorks />
      <MeetYourTeam />
      <AtAGlanceSection
        utmCampaign={utmCampaign}
        utmMedium={utmMedium}
        utmSource={utmSource}
      />
      <MounjaroFAQsMedicallySupported />
      <Footer />
    </>
  );
};

export default MedicationSupportedProgramme;
